import * as React from "react";
import { forwardRef } from "react";
const SvgIconGoogleBookmark = ({
  title,
  titleId,
  ...props
}, ref) => /* @__PURE__ */ React.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", width: 10, height: 12, viewBox: "0 0 10 12", fill: "none", ref, "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React.createElement("path", { d: "M8.3335 0H1.66683C0.933496 0 0.333496 0.6 0.333496 1.33333V12L5.00016 10L9.66683 12V1.33333C9.66683 0.6 9.06683 0 8.3335 0ZM8.3335 10L5.00016 8.54667L1.66683 10V1.33333H8.3335V10Z", fill: "#525A5C" }));
const ForwardRef = forwardRef(SvgIconGoogleBookmark);
export default ForwardRef;
